export function showNotify(
  title: string,
  body: string,
  onClick: () => void,
  options: ConstructorParameters<typeof Notification>[1] & { image?: string } = {},
) {
  if (!window.Notification) {
    return;
  }

  if (Notification.permission !== 'granted') {
    return;
  }
  const notification = new Notification(title, {
    ...options,
    body,
  });
  notification.onclick = () => {
    onClick();
    window.focus();
    notification.close();
  };
}
